'use client';

import type {ChangeEventHandler} from 'react';
import type {Strings} from '../library/types';
import type {Locale} from '../../i18n.config';
import ChevronDown from '../assets/icons/chevron-down.svg';
import {languages, localizePath} from '../library/languages';
import {usePathname, useRouter} from 'next/navigation';
import {i18n} from '../../i18n.config';

type Props = {
  strings: Strings;
  locale: Locale;
};

export default function Switcher({strings, locale}: Props) {
  const pathname = usePathname();
  const router = useRouter();

  const handleChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
    const newLocale = event.target.value as Locale;

    if (pathname === null) {
      return;
    }

    if (pathname === `/${locale}` || pathname.startsWith(`/${locale}/`)) {
      const pathnameWithoutLocale = pathname.slice(locale.length + 1);
      router.push(localizePath(pathnameWithoutLocale, newLocale) || '/');
    } else {
      router.push(localizePath(pathname, newLocale) || '/');
    }
  };

  return (
    <div className="relative inline-block w-56">
      <select
        className="block w-full appearance-none rounded-md border border-gray-800 bg-gray-900 bg-opacity-25 py-2 pl-4 pr-8 leading-tight "
        value={locale}
        onChange={handleChange}
        aria-label={strings.switcher.label}>
        {i18n.locales.map((code) => {
          const data = languages[code];
          return (
            <option key={code} value={code}>
              {data.flag} &nbsp; {data.name} - {data.nativeName}
            </option>
          );
        })}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
        <ChevronDown className="w-4" />
      </div>
    </div>
  );
}
